module.exports = __webpack_public_path__ + "static/media/industries-plastic-s.3663cc4f.jpg";